//cs-ecommerce/src/store/product/getters.js
export function peopleListGetter (state) {
    return state.peopleList;
}

/*
export function bayiMailListGetter (state) {
    return state.bayiList.filter(category => category.TYPUPIDX==0);
}
*/